
<div class="modal active">
  <div class="modal__container">
    <div class="fields">
      <h2>{{title}}</h2>
      <div class="close" (click)="close()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <form autocomplete="off"  #ngForm="ngForm" name="colorIntervals" id="configureImportFlightFields" class="active">
        <div class="fields__block">
          <div class="fields__block__section">
            <div class="title">
              <h4>Color Intervals</h4>
              <span> </span>
            </div>
            <div class="table-fields">
              <div style="overflow-y: scroll; height: 300px;">
                <table>
                  <caption>
                  </caption>
                  <thead>
                    <tr>
                      <th scope="col">Min Value</th>
                      <th scope="col">Max Value</th>
                      <th scope="col">Color</th>
                    </tr>
                  </thead>
                    <tbody>
                      <tr *ngFor="let interval of colorIntervals; let i = index" [style.background-color]="!validIntervals[i]? '#ff8d8d' : (i == selected?  'gray': '')" (click)="i != selected ? selected = i: selected = null">
                        <td>
                          <input type="number" [(ngModel)]="interval.minValue" *ngIf="!interval.isMinValueInfinite" name="min_value{{i}}"  (ngModelChange)="checkIntersections(i)" />
                          <input type="text" value="-Infinity" readonly *ngIf="interval.isMinValueInfinite" name="min_value{{i}}"/>

                          <input type="checkbox" style="margin: 8px;top: 2px;position: relative;" (change)="changeValueToInfinite(i,interval.isMinValueInfinite,false)" [(ngModel)]="interval.isMinValueInfinite"  name="minIsInfinite_{{i}}" [checked]="interval.isMinValueInfinite" />
                          <label for="minIsInfinite_{{i}}" style="width: auto;">
                            -Infinity
                          </label>
                        </td>
                        <td>
                          <input type="number" [(ngModel)]="interval.maxValue" *ngIf="!interval.isMaxValueInfinite" name="max_value{{i}}"  (ngModelChange)="checkIntersections(i)" />
                          <input type="text" value="Infinity" readonly *ngIf="interval.isMaxValueInfinite" name="max_value{{i}}"/>

                          <input type="checkbox" style="margin: 8px;top: 2px;position: relative;" (change)="changeValueToInfinite(i,interval.isMaxValueInfinite,true)" [(ngModel)]="interval.isMaxValueInfinite" name="maxIsInfinite_{{i}}" [checked]="interval.isMaxValueInfinite"/>
                          <label for="maxIsInfinite_{{i}}"  style="width: auto;">
                            Infinity
                          </label>
                        </td>
                        <td>
                          <input type="color" [(ngModel)]="interval.color" name="colorInterval_{{i}}" />
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
                <div class="fields__btn" style="background-color: transparent;text-align: right;padding: 10px;">
                  <button class="blue" (click)="add()">Add</button>
                  <button class="blue" style="margin-right: 0px;" (click)="remove()">Remove</button>
                </div>
            </div>
          </div>
        </div>
        <div class="fields__btn">
          <button type="submit" [ngClass]="!checkFormValidity() ? 'gray': 'blue'" (click)="ok()" [disabled]="!checkFormValidity()">
            OK
          </button>
          <button class="gray" (click)="close()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>
